import jQuery from "jquery";
import * as alertify from "alertifyjs";
import "alertifyjs/build/css/alertify.css";
import "alertifyjs/build/css/themes/bootstrap.css";

window.alertify = alertify;

alertify.defaults.transition = "slide";
alertify.defaults.theme.ok = "btn btn-success";
alertify.defaults.theme.cancel = "btn btn-danger";
alertify.defaults.theme.input = "form-control";


window.ajaxNotification = function (xmlHttpResponse) {
    if (!xmlHttpResponse.message || !xmlHttpResponse.status) {
        return;
    }
    alertify.notify(xmlHttpResponse.message, xmlHttpResponse.status, 15);
};

jQuery(document).on('click', 'a[rel="link-confirm"]', function () {
    var msg = jQuery(this).data('confirm-message');
    var titledata = jQuery(this).data('title');
    var link = jQuery(this).attr('href');
    var title = 'Potwierdź akcję';
    if (titledata !== '' && typeof titledata !== 'undefined') {
        title = titledata;
    }
    alertify.defaults.glossary.title = title;
    alertify.defaults.glossary.ok = 'Tak';
    alertify.defaults.glossary.cancel = 'Nie';
    alertify.defaults.transition = 'fade';
    alertify.confirm(msg, function () {
        window.location = link;
    });
    return false;
});

jQuery(document).on('click', 'a[rel="link-info"]', function () {
    var titledata = jQuery(this).data('title');
    var msg = jQuery(this).data('message');
    var link = jQuery(this).attr('href');
    var title = 'Uwaga';
    if (titledata !== '' && typeof titledata !== 'undefined') {
        title = titledata;
    }

    alertify.defaults.glossary.title = title;
    alertify.defaults.glossary.ok = 'OK';
    alertify.defaults.transition = 'fade';
    alertify.alert(title, msg, function () {
        if (link !== '' && typeof link !== 'undefined') {
            window.location = link;
        }
    });
    return false;
});